import { BaseField } from '@epages/react-components'
import { useContext } from 'react'
import PropTypes from 'prop-types'

/*
 * Gets the error of a current form value defined by `name` from  the `context`
 */
function FormValueError({ name, children }) {
  const context = useContext(BaseField.contextType)

  return children(context.instance.getError(name))
}

FormValueError.propTypes = {
  ...BaseField.propTypes,
  children: PropTypes.func.isRequired,
}

export default FormValueError
